import { render, staticRenderFns } from "./WarrantedFilterDesktopSerp.vue?vue&type=template&id=0a2fedec&"
import script from "./WarrantedFilterDesktopSerp.vue?vue&type=script&lang=ts&"
export * from "./WarrantedFilterDesktopSerp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports